import { all, takeEvery, takeLatest, put, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { invitationActionTypes } from './Invitation.actionTypes';
import service from '../../services/invitation';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';

export function* getInvitationDetailsSaga({ payload }) {
  yield put({ type: invitationActionTypes.GET_INVITATION_DETAILS_PENDING });
  try {
    const { invitationId } = payload;

    const response = yield call(service.getInvitationDetails, invitationId);

    if (response.success) {
      yield put({
        type: invitationActionTypes.GET_INVITATION_DETAILS_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: invitationActionTypes.GET_INVITATION_DETAILS_FAILED,
        payload: response,
      });
    }
  } catch (e) {
    yield put({
      type: invitationActionTypes.GET_INVITATION_DETAILS_FAILED,
      payload: e,
    });
  }
}

export function* acceptInvitationSaga({ payload }) {
  yield put({ type: invitationActionTypes.ACCEPT_INVITATION_PENDING });
  try {
    const response = yield call(service.acceptInvitation, { ...payload });
    if (response.success) {
      yield put({
        type: invitationActionTypes.ACCEPT_INVITATION_SUCCESS,
        payload: response.data,
      });
      addNotification({
        message: 'Invite Accepted!',
        level: notificationStates.success,
      });
      if (payload.callback) {
        payload.callback();
      } else {
        yield put(push('/'));
      }
    } else {
      yield put({
        type: invitationActionTypes.ACCEPT_INVITATION_FAILED,
        payload: response,
      });
      addNotification({
        message: 'Something went wrong! Please try again later.',
        level: notificationStates.error,
      });
    }
    yield put({ type: invitationActionTypes.ACCEPT_INVITATION_CLEANUP });
  } catch (e) {
    yield put({
      type: invitationActionTypes.ACCEPT_INVITATION_FAILED,
      payload: e,
    });
    yield put({ type: invitationActionTypes.ACCEPT_INVITATION_CLEANUP });
    addNotification({
      message: 'Something went wrong! Please try again later.',
      level: notificationStates.error,
    });
  }
}

export default function* invitationWatcher() {
  yield all([
    takeEvery(
      invitationActionTypes.GET_INVITATION_DETAILS,
      getInvitationDetailsSaga
    ),
    takeEvery(invitationActionTypes.ACCEPT_INVITATION, acceptInvitationSaga),
  ]);
}
